export default {
  timeSheetDocument: undefined,
  timeSheetDocuments: [],
};
